import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import './Subscriptions.css';
import { useUser, useUserUpdater } from '../App';

const Subscriptions = () => {
    const [tariffs, setTariffs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    
    const user = useUser();
    const updateUser = useUserUpdater();
    const navigate = useNavigate();

    const fetchTariffs = useCallback(async () => {
        try {
            const response = await fetch('/api/tariffs');
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            const data = await response.json();
            data.sort((a, b) => {
                if (a.name === "Пробная") return -1;
                if (b.name === "Пробная") return 1;
                return a.price - b.price;
            });
            setTariffs(data);
        } catch (e) {
            setError(e.message);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchTariffs();
    }, [fetchTariffs]);

    const handlePurchase = async (tariff) => {
        const tg = window.Telegram?.WebApp;
        if (!user || !tg) {
            tg.showAlert('Не удалось получить данные. Попробуйте перезапустить приложение.');
            return;
        }

        let useBonuses = false;
        if (user.bonus_balance > 0 && tariff.name !== "Пробная") {
            const potentialDiscount = Math.min(user.bonus_balance, tariff.price);
            
            tg.showConfirm(
                `Вам доступно ${user.bonus_balance} бонусов. Хотите списать ${potentialDiscount} для получения скидки?`,
                async (confirmed) => {
                    if (confirmed) {
                        useBonuses = true;
                    }
                    await proceedWithPurchase(tariff.id, useBonuses);
                }
            );
        } else {
            await proceedWithPurchase(tariff.id, false);
        }
    };

    const proceedWithPurchase = async (tariffId, useBonuses) => {
        const tg = window.Telegram?.WebApp;
        if (!tg) return;
        
        // Показываем индикатор загрузки через основной интерфейс
        tg.MainButton.setText('Обработка...');
        tg.MainButton.show();

        try {
            const response = await fetch('/api/payment/create', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'init-data': tg.initData
                },
                body: JSON.stringify({ 
                    tariff_id: tariffId,
                    use_bonuses: useBonuses 
                }),
            });

            tg.MainButton.hide();

            if (!response.ok) {
                const errorData = await response.json().catch(() => ({ detail: 'Произошла неизвестная ошибка.' }));
                throw new Error(`Ошибка сервера: ${response.status} - ${errorData.detail}`);
            }

            const data = await response.json();

            if (data.activated_by_bonuses) {
                tg.showAlert('Поздравляем! Подписка успешно активирована за бонусы.');
                updateUser();
                navigate('/profile');
            } else if (data.confirmation_url) {
                // Открываем ссылку оплаты в Telegram WebApp
                tg.openLink(data.confirmation_url);
                
                // Показываем сообщение пользователю
                tg.showAlert('Завершите оплату и вернитесь в бот. Ваш ключ появится в личном кабинете после успешной оплаты.');
            } else {
                throw new Error('Не удалось получить ссылку для оплаты.');
            }

        } catch (err) {
            tg.MainButton.hide();
            tg.showAlert(`Ошибка при создании платежа: ${err.message}`);
            console.error(err);
        }
    };

    if (loading) {
        return <div className="loading-message">Загрузка тарифов...</div>;
    }

    if (error) {
        return <div className="error-message">Ошибка: {error}</div>;
    }

    return (
        <div className="page-container" style={{paddingTop: '60px'}}>
            <h1 className="page-title">Выбрать подписку</h1>
            <div className="tariffs-grid">
                {tariffs.map((tariff) => (
                    <div key={tariff.id} className="tariff-card">
                        <h2 className="tariff-name">{tariff.name}</h2>
                        <p className="price">{tariff.price} руб.</p>
                        <p className="duration">Длительность: {tariff.duration_days} дней</p>
                        {tariff.data_limit_gb && (
                            <p className="traffic-limit">Ограничение трафика: {tariff.data_limit_gb} ГБ</p>
                        )}
                        <button 
                            onClick={() => handlePurchase(tariff)} 
                            className="buy-button"
                        >
                            Выбрать
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Subscriptions; 
